<template>
    <td id="pricelistMassAction" v-if="action && action !== 'deleteLines'" :rowspan="rowspan">
        <label v-if="action !== 'updatePrice'">Значение</label>

        <select
            v-if="action === 'declineTag'"
            :class="{large: true, hasError: error}"
            v-tooltip="{
                content: error,
                template: $errTemplate
            }"
            v-model="optional"
        >
            <option
                v-for="operationObject in operationsArray"
                :value="operationObject.id"
                :selected="optional === operationObject.id"
            >{{operationObject.name}}
            </option>
        </select>

        <select-tags
            v-if="action === 'appendTag'"
            ref="selectTags"
            @selected="(id) => setOptional(id)"
            :class="{hasError: error}"
            v-tooltip="{
                content: error,
                template: $errTemplate
            }"
        />

        <selector
            :options="operationsArray"
            v-if="action === 'deleteCategory'"
            @selected="(category) => setOptional(category)"
            :class="{hasError: error}"
            v-tooltip="{
                content: error,
                template: $errTemplate
            }"
        />

        <input
            v-if="action === 'updateCategory'"
            v-model="optional"
            :class="{large: true, hasError: error}"
            v-tooltip="{
                content: error,
                template: $errTemplate
            }"
        >

        <price-inputs
            ref="priceInputs"
            v-if="action === 'updatePrice'"
            @setOptional="(price) => setOptional(price)"
        />
    </td>
</template>

<script>
    import SelectTags from "./SelectTags";
    import Selector from "./Selector"
    import PriceInputs from "./PriceInputs"
    export default {
        components: {PriceInputs, Selector, SelectTags},
        props: {
            action: {type: String, default: null},
            selectedPriceLines: {type: Array, required: true}
        },
        data: () => ({
            lineIdsArray: [],
            operationsArray: [],
            optional: null,
            withReset: false,
            error: null,
        }),
        emits: ['actionEnded'],
        watch: {
            action() {
                this.prepareActions()
            }
        },
        methods: {
            reset() {
                this.lineIdsArray = []
                this.operationsArray = []
                this.optional = null
                this.error = null
            },
            setOptional(id) {
                this.optional = id
            },
            prepareActions() {
                this.reset()
                const nothingToPrepare = [
                    'deleteLines',
                    'appendTag',
                ]
                if (! nothingToPrepare.includes(this.action)) {
                    this[this.action + 'Prepare']()
                }
                if (this.action === 'appendTag') {
                    setTimeout(() => {
                        this.$refs.selectTags.$refs.searchTags.$refs.multiselect.isOpen = true;

                        setTimeout(() => {
                            this.$refs.selectTags.$refs.searchTags.$refs.multiselect.$refs.search.focus();
                        }, 1);
                    }, 1);
                }
            },
            startAction(withReset, btn) {
                if (this.action) {
                    this.withReset = withReset;
                    this[this.action](btn)
                }
            },
            sendEmits() {
                this.$emit('updateTable', this.withReset)
                this.$emit('done')
            },
            deleteLines(btn) {
                let lineIds = [];

                this.selectedPriceLines.forEach(line => {
                    lineIds.push(line.id);
                })

                this.axios
                    .post(this.uri, lineIds)
                    .then(response => {
                        this.sendEmits()
                        this.$emit('actionEnded')
                    })
            },
            appendTag(btn) {
                if (!this.optional) {
                    this.error = 'Тег не выбран';
                    this.$emit('actionEnded')
                    return;
                }

                this.error = null;
                let lineIds = [];

                this.selectedPriceLines.forEach(line => {
                    lineIds.push(line.id);
                })

                this.axios
                    .post(this.uri, {tag: this.optional, linesIds: lineIds})
                    .then(response => {
                        if (response.data) {
                            this.$emit('tagsUpdated', response.data)
                        }
                        this.sendEmits()
                        this.$emit('actionEnded')
                    })
            },
            declineTagPrepare() {
                this.selectedPriceLines.forEach(el => {
                    Object.values(el.services).forEach(service => {
                        if (! this.operationsArray.some(s => s.id === service.id)) {
                            if (service.status === 'ACCEPTED' || service.status === 'ACCEPTED_MANUAL' || service.status === 'NEW') {
                                this.operationsArray.push(service)
                            }
                        }
                    })
                })
            },
            declineTag(btn) {
                if (!this.optional) {
                    this.error = 'Тег не выбран';
                    this.$emit('actionEnded')
                    return;
                }

                this.error = null;
                this.selectedPriceLines.forEach((line, index) => {
                    let serviceIndex;
                    for (const [i, item] of Object.entries(line.services)) {
                        if (
                            item.id === this.optional &&
                            (item.status === 'ACCEPTED' || item.status === 'ACCEPTED_MANUAL' || item.status === 'NEW')
                        ) {
                            serviceIndex = i;
                        }
                    }

                    if (serviceIndex) {
                        if (! this.lineIdsArray.some(el => el.id === line.id)) {
                            this.lineIdsArray.push(line.id)
                        }

                        this.selectedPriceLines[index].services[serviceIndex].status = 'DECLINED_MANUAL';
                    }
                })

                this.axios
                    .post(this.uri, {tag:this.optional, lines:this.lineIdsArray})
                    .then(response => {
                        this.sendEmits()
                        this.$emit('actionEnded')
                    })
            },
            updateCategoryPrepare() {
                this.selectedPriceLines.forEach(line => {
                    this.lineIdsArray.push({id: line.id, category: this.optional})
                })
            },
            updateCategory(btn) {
                if (!this.optional) {
                    this.error = 'Категория не выбрана';
                    this.$emit('actionEnded')
                    return;
                }

                this.error = null;
                this.axios
                    .post(this.uri, {lines: this.lineIdsArray, category: this.optional})
                    .then(response => {
                        this.sendEmits()
                        this.$emit('actionEnded')
                    })
            },
            deleteCategoryPrepare() {
                this.selectedPriceLines.forEach(line => {
                    this.lineIdsArray.push({id: line.id, category: line.category})
                    let category = line.category && line.category.length ? line.category[0] : null;
                    if (category && !this.operationsArray.includes(category)) {
                        this.operationsArray.push(category)
                    }
                })
            },
            deleteCategory(btn) {
                if (!this.optional) {
                    this.error = 'Категория не выбрана';
                    this.$emit('actionEnded')
                    return;
                }

                this.error = null;
                this.axios
                    .post(this.uri, {lines: this.lineIdsArray, category: this.optional})
                    .then(response => {
                        this.sendEmits()
                        this.$emit('actionEnded')
                    })
            },
            updatePricePrepare() {
                this.selectedPriceLines.forEach(line => {
                    this.lineIdsArray.push(line.id)
                })
            },
            updatePrice(btn) {
                this.$refs.priceInputs.$refs.validator.validate()
                    .then(success => {
                        if (this.optional && success) {
                            this.axios
                                .post(this.uri, {lines: this.lineIdsArray, prices: this.optional})
                                .then(response => {
                                    this.sendEmits()
                                    this.$emit('actionEnded')
                                })
                        } else {
                            this.$emit('actionEnded')
                        }
                    })
            },
        },
        computed: {
            uri() {
                return 'doctu/lines/mass/' + this.action
            },
            rowspan() {
                if (this.action === 'updatePrice') return 2
            }
        }
    }
</script>

<style>
#pricelistMassAction .multiselect__tags {
    height: 34px !important;
    line-height: 34px;
}
#pricelistMassAction .multiselect__select {
    height: 34px !important;
}
#pricelistMassAction .multiselect__placeholder {
    font-size: 24px !important;
}
#pricelistMassAction .multiselect__input {
    height: 34px !important;
    font-size: 24px !important;
    font-family: "PT Sans", sans-serif !important;
}
#pricelistMassAction .multiselect__single {
    vertical-align: middle;
}
</style>
